import {customElement, property} from "lit/decorators.js";
import {UnLitElement} from "../../../common/elements";
import {html, type TemplateResult} from "lit";
import {GLOBAL} from "../../../common/globals";
import {EventBus} from "../../../common/eventBus";
import {resolve} from "../../../container";
import {ManagingResources} from "../../../common/lifetime";
import {prepareEvents} from "../../../common/utils/events";
import {clamp} from "../../../bootstrap/common/numbers";
import {MOBILE_MENU_CLOSED, MOBILE_MENU_OPENED} from "./mobile/mobileHeaderEvents";
import {HEADER_OPACITY_CHANGED_EVENT, HEADER_WITH_STABLE_OPACITY_EVENT, type HeaderOpacityChangedEventData} from "./header";


export const SCROLL_PROGRESS_END_ATTRIBUTE = "scroll-progress-end";

@customElement("eop-scroll-progress-bar")
export class EopScrollProgressBar extends ManagingResources(UnLitElement) {

    @property({attribute: "show-bar", type: Boolean, reflect: true})
    public showBar: boolean = false;
    @property({attribute: "enabled", type: Boolean})
    public enabled: boolean = false;

    public constructor(private eventBus: EventBus = resolve(EventBus)) {
        super();
    }

    public connectedCallback(): void {
        super.connectedCallback();

        prepareEvents(GLOBAL.window())
            .boundTo(this)
            .on("scroll", () => this.updateProgress());
        this.eventBus.on(HEADER_WITH_STABLE_OPACITY_EVENT, () => this.enabled = true);
        this.eventBus.on<HeaderOpacityChangedEventData>(HEADER_OPACITY_CHANGED_EVENT, event => this.enabled = event.data.nowOpaque);
        this.eventBus.on(MOBILE_MENU_OPENED, () => this.showBar = false);
        this.eventBus.on(MOBILE_MENU_CLOSED, () => this.updateProgress());
    }

    public render(): TemplateResult {
        return html`
            <div class="scroll-progress-bar"></div>
        `;
    }

    private updateProgress(): void {
        const scrollY = GLOBAL.window().scrollY;
        const startElementBottomY = this.determineStartElementBottomY();
        const endElementTopY = this.determineEndElementTopY();
        const scrollableDistance = endElementTopY - GLOBAL.window().innerHeight - startElementBottomY;
        const scrollProgress = scrollableDistance > 0
            ? clamp((scrollY - startElementBottomY) / scrollableDistance, 0, 1)
            : 1;
        this.style.setProperty("--scroll-progress", String(scrollProgress));

        this.showBar = scrollProgress > 0 && this.enabled;
    }

    private determineStartElementBottomY(): number {
        const scrollY = GLOBAL.window().scrollY;
        const staticHeader = GLOBAL.document().querySelector("header:not(.sticky)");
        return staticHeader
            ? staticHeader.getBoundingClientRect().bottom + scrollY
            : 0;
    }

    private determineEndElementTopY(): number {
        const scrollY = GLOBAL.window().scrollY;
        const endSection = GLOBAL.document().querySelector(`section[${SCROLL_PROGRESS_END_ATTRIBUTE}]`);
        const footer = GLOBAL.document().querySelector("footer");
        const endElement = endSection ?? footer;
        return endElement
            ? endElement.getBoundingClientRect().top + scrollY
            : GLOBAL.document().body.scrollHeight;
    }
}